import { ISession, GET_CURRENT_SESSION } from '../types/session.types';
import authApolloClient from './apollo.authClient';

export const getCurrentSession = async (sessionId: string, shouldRefresh = false): Promise<ISession | null> => {
  try {
    const res = await authApolloClient.query({
      query: GET_CURRENT_SESSION,
      context: {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      },
      variables: {
        refresh: shouldRefresh,
      },
    });
    return res.data?.getSession;
  } catch (e) {
    console.error('🚀 ~ getCurrentSession ~ e:', e);
    return null;
  }
};

export const getClientSideSession = async (shouldRefresh = false): Promise<ISession | null> => {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    const platform = url.searchParams.get('platform') || '';
    const isAppUser = Boolean(platform === 'app');
    const sessionId = url.searchParams.get('sessionId') || '';

    if (sessionId) {
      const data = await getCurrentSession(sessionId || '', shouldRefresh);

      if (data) {
        return data;
      } else {
        return null;
      }
    } else if (isAppUser) {
      const accessToken = url.searchParams.get('accessToken') || '';
      const idToken = url.searchParams.get('idToken') || '';
      return {
        accessToken,
        idToken,
        sessionId: '',
      };
    } else {
      return null;
    }
  } else {
    return null;
  }
};
